import React from 'react';
import { useState } from "react";
import { useSelector } from 'react-redux';
import Page from '../../components/Page';
import {
    Box,
    Typography,
    Button,
    Hidden,
    Modal,
    FormControl,
    InputLabel,
    Select
} from '@mui/material';
import {
    DataGrid,
} from '@mui/x-data-grid';
import { Check, PlusSquare } from 'react-feather';
import CreateUser from './CreateUser';
import CheckUser from './CheckUser';
import UserRoleChange from './UserRoleChange';
import EmployeeRoleCell from './EmployeeRoleCell';
import { createEmployeeStatusColumn, EmployeeDataGridToolbar } from './employeeTableColumns';
import "./Users.css";
import { useCompanyUsers, useDeactivateEmployee } from '../../hooks/useCompanyUsers';

const UserPage = () => {
    const [open, setOpen] = React.useState(false);
    const [check, setCheck] = React.useState(false);
    const company = useSelector((state) => state.CompanyReducer.userCompanies[0])
    const { data: users = [] } = useCompanyUsers({
        companyId: company?.id,
        menuType: 1,
        enabled: Boolean(company?.id),
    });
    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = () => setOpen1(true);
    const handleClose1 = () => setOpen1(false);
    const deactivateEmployeeMutation = useDeactivateEmployee();
    const [rowItem, setRowItem] = useState();

    function editRole(cellValues) { // hadles the double click to bring up modal to edit crop amount
        setRowItem({
            userId: cellValues.row.id,
            userRole: cellValues.row.userRole,
        });
        handleOpen1();
    };

    function deactivateEmployee(cellValues){
        setRowItem({
            userId: cellValues.row.id,
        });
        deactivateEmployeeMutation.mutate({Id: cellValues.row.id, CompanyId: company.id});
    };

    const columns = [
        { field: 'userName', headerName: 'Username', width: 200, headerClassName: 'header' },
        { field: 'email', headerName: 'Email', width: 300, headerClassName: 'header' },
        { field: 'firstName', headerName: 'First Name', width: 150, headerClassName: 'header' },
        { field: 'lastName', headerName: 'Last Name', width: 150, headerClassName: 'header' },
        { field: 'userRole', headerName: 'Role', width: 250, headerClassName: 'header',
            renderCell: (cellValues) => (
                <EmployeeRoleCell cellValues={cellValues} onEdit={editRole} />
            )
        },
        createEmployeeStatusColumn(deactivateEmployee),
    ];

    const handleOpen = () => setOpen(!open);
    const handleCheck = () => setCheck(!check);

    return (
        <Page title="Employees">
            <Box p={3} sx={{ '& .header': { backgroundColor: '#e2e2e2' } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant='h3' textAlign='left' p={2}>
                        Employees
                    </Typography>
                    <Button
                        variant='text'
                        color='warning'
                        startIcon={<PlusSquare/>}
                        onClick={handleOpen}
                    >
                        New User
                    </Button>
                    <Modal open={open} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CreateUser close={handleOpen}/>
                    </Modal>
                    <Modal open={check} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CheckUser close={handleCheck}/>
                    </Modal>
                </Box>
                <DataGrid
                    columns={columns}
                    rows={users}
                    style={{textAlign:'left', height:'70vh'}}
                    components={{
                        Toolbar: EmployeeDataGridToolbar,
                    }}
                />
                <Modal
                    open={open1}
                    onClose={handleClose1}
                    className="employeeStatusModal"
                >
                <UserRoleChange item={rowItem} handleClose1={handleClose1}/>
                </Modal>
            </Box>
        </Page>
    )
};

export default UserPage;